import { ApiService } from "../../../services/ApiService";
import { GET_ALL_HOLIDAYS, GET_ALL_LEAVE_RECORD } from "../../actionTypes";

export class holidaysMngtThunk {
  static getAllHOlidays(query = "?page=1") {
    return async (dispatch) => {
      try {
        const response = await ApiService.get(`leave-requests${query}`);
        if (response.data) {
          dispatch({
            type: GET_ALL_HOLIDAYS,
            payload: response.data,
          });
          return;
        }
      } catch (err) {}
    };
  }

  static getLeaveRecord() {
    return async (dispatch) => {
      try {
        const response = await ApiService.get("reporting/leave-summary");
        if (response.data) {
          dispatch({
            type: GET_ALL_LEAVE_RECORD,
            payload: response.data,
          });
          return;
        }
      } catch (err) {}
    };
  }
}



// WEBPACK FOOTER //
// ./src/store/actions/holidaymanagement/holiday.thunk.js